/** Query param SocialAuthCallback sets on /login when the account is waiting for staff approval. */
export const LOGIN_STATUS_PARAM = 'status';
export const LOGIN_STATUS_PENDING = 'pending';
